import { BaseApi } from '../../api/apiBase'
import { ExhibitorsResponse, ExhibitorResponse } from '../types/exhibitor.types'

class ExhibitorsApi extends BaseApi {
  constructor() {
    super('/api/portal')
  }

  async getExhibitors(eventSlug: string): Promise<ExhibitorsResponse> {
    // Use getSimpleJson for non-JSON:API responses
    // BaseApi's getSimpleJson automatically transforms snake_case to camelCase
    const response = await this.getSimpleJson<ExhibitorsResponse>(
      `/events/${eventSlug}/exhibitors`
    )
    
    return response
  }

  async getExhibitor(eventSlug: string, exhibitorId: string, skipViewTracking = false): Promise<ExhibitorResponse> {
    const params = skipViewTracking ? '?skip_view_tracking=true' : ''
    const response = await this.getSimpleJson<ExhibitorResponse>(
      `/events/${eventSlug}/exhibitors/${exhibitorId}${params}`
    )
    
    return response
  }

  async trackCtaClick(eventSlug: string, exhibitorId: string): Promise<{ success: boolean; message: string; trackOnly?: boolean }> {
    const response = await this.postSimpleJson<{ success: boolean; message: string; trackOnly?: boolean }>(
      `/events/${eventSlug}/exhibitors/${exhibitorId}/track_cta`,
      {}
    )
    
    return response
  }
}

export const exhibitorsApi = new ExhibitorsApi()